module.exports = __webpack_public_path__ + "static/media/passatempos_1.09694b6a.png";